import {
  type AffectedProject,
  type Category,
  type Issue,
  IssueScopeKind,
  type Scope,
} from '../../../../../../shared/issuesV2';
import { getIssueDetailURLForScope } from '../../../IssueDetails/ProjectsTable/utils';

type GetJiraTicketAffectedProjectURLForScope = {
  affectedProject: AffectedProject;
  scope: Scope;
  issueCategory: Category;
  issueId: number;
  revisionScanId?: number;
};

/**
 * Wrapper around getIssueDetailURLForScope that returns a string URL pointing to the an affected project for Jira tickets.
 */
export const getJiraTicketAffectedProjectURLForScope = ({
  affectedProject,
  scope,
  issueCategory,
  issueId,
  revisionScanId,
}: GetJiraTicketAffectedProjectURLForScope) => {
  const url = getIssueDetailURLForScope({
    affectedProject,
    scope,
    issueCategory,
    issueDetailsURL: '',
    issueDetails: {
      id: issueId,
    } as Issue,
  });

  // Release group handles issues separately, so we can't directly link to the issue in a project.
  // However, we can still link the user to the project summary page.
  return revisionScanId && scope.type !== IssueScopeKind.ReleaseGroup ? `${url}?revisionScanId=${revisionScanId}` : url;
};
